import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Check, AlertTriangle, Folder, PenTool } from 'lucide-react';
import { Countdown } from './Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-14 bg-petroleum relative overflow-hidden" data-id="element-541">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-50" data-id="element-542"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-543">
        {/* Scarcity Header */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-544">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full text-sm font-bold mb-5" data-id="element-545">
            <AlertTriangle className="w-4 h-4" data-id="element-546" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-5" data-id="element-547">
            <Countdown data-id="element-548" />
          </div>

          <p className="text-textsecondary mb-2" data-id="element-549">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>
          <p className="text-energy font-medium flex items-center justify-center gap-2" data-id="element-550">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-551">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-yellow-300 to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-552"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-553">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(201,151,30,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(201,151,30,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-554"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-555"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-556"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-557"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-558"></div>

            <div className="relative z-10" data-id="element-559">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-electric text-graphite border border-electric px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-560">
                <Zap className="w-3.5 h-3.5 fill-graphite" data-id="element-561" />
                Acceso Instantáneo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 flex-wrap" data-id="element-562">
                <Zap className="w-7 h-7 md:w-9 md:h-9 text-gold fill-gold drop-shadow-[0_0_8px_rgba(212,166,42,0.6)]" data-id="element-563" />
                <span className="text-white" data-id="element-564">ELEGÍ TU</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-yellow-300 to-electric drop-shadow-[0_0_12px_rgba(201,151,30,0.4)]" data-id="element-565">
                  SUPERPACK
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-566"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-567">
          {/* Basic Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-graphite border border-white/10 rounded-3xl p-8 hover:border-electric/30 transition-all relative mt-4" data-id="element-568">
            {/* Card Folder Tab */}
            <div className="absolute -top-4 left-6 z-20" data-id="element-569">
              <div className="bg-petroleum border border-electric/40 rounded-t-lg px-3 py-1 flex items-center gap-1.5 transform -rotate-1" data-id="element-570">
                <Folder className="w-3 h-3 text-electric" data-id="element-571" />
                <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-electric" data-id="element-572">
                  Oferta A — Esencial
                </span>
              </div>
            </div>

            {/* Ruled-paper lines */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-0 rounded-3xl" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 32px)'
          }} data-id="element-573"></div>

            <div className="relative z-10" data-id="element-574">
              {/* Metadata header strip */}
              <div className="border-b border-dashed border-white/10 pb-2 mb-4 text-[10px] font-mono uppercase tracking-widest text-textsecondary flex justify-between" data-id="element-575">
                <span data-id="element-576">Contrato N° 14.490</span>
                <span data-id="element-577">Estándar</span>
              </div>

              <div className="mb-6 pt-2" data-id="element-578">
                <h3 className="text-2xl font-bold leading-tight mb-1.5 flex items-start gap-2" data-id="element-579">
                  <Zap className="w-5 h-5 text-electric fill-electric mt-1 flex-shrink-0" data-id="element-580" />
                  <span data-id="element-581">SUPERPACK ENTREVISTAS</span>
                </h3>
                <p className="text-sm text-textsecondary" data-id="element-582">6 Tomos + 6 Bonos</p>
              </div>

              <div className="bg-cardbg rounded-xl p-4 mb-8 border border-white/5" data-id="element-583">
                <p className="text-sm text-textsecondary mb-1 font-mono uppercase tracking-wider text-[10px]" data-id="element-584">
                  Perfil Requerido:
                </p>
                <p className="font-medium text-sm" data-id="element-585">
                  Personas que quieren un sistema completo para conseguir
                  entrevistas en Argentina desde cero.
                </p>
              </div>

              <div className="mb-8" data-id="element-586">
                <span className="text-textsecondary line-through text-xl" data-id="element-587">
                  $29.990
                </span>
                <div className="flex items-baseline gap-2" data-id="element-588">
                  <span className="text-4xl font-extrabold text-white" data-id="element-589">
                    $14.490
                  </span>
                  <span className="text-textsecondary font-medium" data-id="element-590">ARS</span>
                </div>
              </div>

              <div className="flex flex-col gap-2" data-id="element-591">
                <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-electric/70 ml-2" data-id="element-592">
                  <PenTool className="w-3 h-3" data-id="element-593" />
                  Firma Digital Requerida
                </div>
                <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCozc29zdZ0C2K8raHFWoE/es-ar?_r=AQAB0salDLYbU5UgFanW6R0pUA1sZzkTGH7zYWd91gxBRt8&cart_link_id=GQstsdmk&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3.5 rounded-xl transition-all duration-300 flex items-center justify-between gap-3 pl-4 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-594">
                  <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-595">
                    <Zap className="w-4 h-4 text-electric fill-electric" data-id="element-596" />
                  </span>
                  <span className="flex-1 text-center text-sm md:text-base tracking-wide" data-id="element-597">
                    ACEPTAR OFERTA A
                  </span>
                  <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-598">
                    <Check className="w-4 h-4" strokeWidth={3} data-id="element-599" />
                  </span>
                </a>
              </div>
            </div>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-cardbg to-petroleum border-2 border-electric rounded-3xl p-8 relative transform md:-translate-y-4 glow-electric mt-4 md:mt-0" data-id="element-600">
            {/* Card Folder Tab */}
            <div className="absolute -top-4 left-6 z-20" data-id="element-601">
              <div className="bg-electric border border-electric rounded-t-lg px-4 py-1.5 flex items-center gap-1.5 transform -rotate-2 shadow-lg" data-id="element-602">
                <Folder className="w-3.5 h-3.5 text-graphite" data-id="element-603" />
                <span className="text-[11px] font-mono font-bold uppercase tracking-widest text-graphite" data-id="element-604">
                  Oferta B — Pro
                </span>
              </div>
            </div>

            {/* Stamp */}
            <div className="absolute top-6 right-6 z-20 pointer-events-none select-none" style={{
            transform: 'rotate(12deg)'
          }} data-id="element-605">
              <div className="border-2 border-gold/80 rounded px-2 py-0.5 bg-graphite/50 backdrop-blur-sm" data-id="element-606">
                <span className="text-gold font-extrabold tracking-widest text-[10px] uppercase" data-id="element-607">
                  Más Popular
                </span>
              </div>
            </div>

            {/* Ruled-paper lines */}
            <div className="absolute inset-0 opacity-[0.04] pointer-events-none z-0 rounded-3xl" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 32px)'
          }} data-id="element-608"></div>

            <div className="relative z-10" data-id="element-609">
              {/* Metadata header strip */}
              <div className="border-b border-dashed border-white/10 pb-2 mb-4 text-[10px] font-mono uppercase tracking-widest text-gold flex justify-between" data-id="element-610">
                <span data-id="element-611">Contrato N° 24.990</span>
                <span data-id="element-612">Premium</span>
              </div>

              <h3 className="text-2xl font-bold mb-2 flex items-center gap-2 mt-2" data-id="element-613">
                SUPERPACK + PROTOCOLO TOTAL
              </h3>
              <p className="text-textsecondary mb-6" data-id="element-614">
                6 Tomos + 6 Bonos + El Protocolo de Entrevista Total
              </p>

              <div className="bg-graphite/50 rounded-xl p-4 mb-8 border border-gold/20" data-id="element-615">
                <p className="text-sm text-gold mb-1 font-mono uppercase tracking-wider text-[10px]" data-id="element-616">
                  Perfil Requerido:
                </p>
                <p className="font-medium text-sm" data-id="element-617">
                  Quien quiere su primera entrevista en 7 días con scripts
                  avanzados de negociación, simulacro de entrevista y sistema de
                  seguimiento profesional.
                </p>
              </div>

              <div className="mb-8" data-id="element-618">
                <span className="text-textsecondary line-through text-xl" data-id="element-619">
                  $42.990
                </span>
                <div className="flex items-baseline gap-2" data-id="element-620">
                  <span className="text-5xl font-extrabold text-white" data-id="element-621">
                    $24.990
                  </span>
                  <span className="text-textsecondary font-medium" data-id="element-622">ARS</span>
                </div>
              </div>

              <div className="flex flex-col gap-2" data-id="element-623">
                <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-gold ml-2" data-id="element-624">
                  <PenTool className="w-3 h-3" data-id="element-625" />
                  Firma Digital Requerida
                </div>
                <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCozpP0Akks8fx9V9l7kEE/es-ar?_r=AQABqGUydzRQpIZhFczAn0kTKpof-0DWODM9u3VFHsdt5wc&cart_link_id=Ycod5L72&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 hover:from-yellow-200 hover:via-yellow-300 hover:to-gold text-graphite font-extrabold rounded-2xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_25px_rgba(212,166,42,0.5)] hover:shadow-[0_0_40px_rgba(212,166,42,0.85)] flex items-center justify-between gap-3 pl-3 pr-3 py-3 uppercase tracking-wide overflow-hidden border-2 border-yellow-200" data-id="element-626">
                  {/* Animated sheen */}
                  <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 pointer-events-none" data-id="element-627"></span>

                  {/* Left icon badge */}
                  <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite/15 backdrop-blur-sm flex items-center justify-center" data-id="element-628">
                    <Zap className="w-5 h-5 fill-graphite text-graphite" data-id="element-629" />
                  </span>

                  {/* Centered label */}
                  <span className="relative z-10 flex-1 text-center text-sm md:text-base leading-tight" data-id="element-630">
                    ACEPTAR OFERTA B
                  </span>

                  {/* Right arrow badge */}
                  <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite text-gold flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 shadow-md" data-id="element-631">
                    <Check className="w-5 h-5" strokeWidth={3} data-id="element-632" />
                  </span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}